import React from 'react';
import './SmallScreens.css';
import MobileHeader from './MobileHeader';

function SmallScreens({
  currentLanguage,
  toggleLanguage,
  updateCityAndRegion,
  user,
  userFullName,
  onLogout,
  updateSelectedLocation,
  children,
  isHeaderOnly = false,
  activeHeroFilter = 'all',
  onHeroFilterChange,
}) {
  return (
    <>
      <MobileHeader
        currentLanguage={currentLanguage}
        toggleLanguage={toggleLanguage}
        updateCityAndRegion={updateCityAndRegion}
        user={user}
        userFullName={userFullName}
        onLogout={onLogout}
        updateSelectedLocation={updateSelectedLocation}
        isHeaderOnly={isHeaderOnly}
        activeHeroFilter={activeHeroFilter}
        onHeroFilterChange={onHeroFilterChange}
      />

      {/* Mobile Content Wrapper (الإعلانات فقط) */}
      {!isHeaderOnly && (
        <div className="mobile-content-wrapper">
          {children}
        </div>
      )}
    </>
  );
}

export default SmallScreens;